import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button, Container, Typography, Select, MenuItem } from '@mui/material';
import { setTheme } from '@modules/ui';
import { useTranslation } from "react-i18next";
import LangButtons from '../../components/_commons/header/langSelect/LangButtons';

function General() {
    const { t } = useTranslation();
    const theme = useSelector(state => state.ui.theme);
    const dispatch = useDispatch();
    const organizationData = useSelector(state => state.organization.organizationData);

    const themesObj = [
        { id: "light", backgroundColorOuter: "#FFFFFF", backgroundColorInner: "#FFFFFF", textColorOuter: "#545454", textColorInner: "#252525" },
        { id: "dark", backgroundColorOuter: "#2E2E2E", backgroundColorInner: "#616161", textColorOuter: "#FFFFFF", textColorInner: "#FFFFFF" },
        { id: "csms", backgroundColorOuter: "#0075F8", backgroundColorInner: "#FFFFFF", textColorOuter: "#FFFFFF", textColorInner: "#252525" },
    ];

    function getUserTheme() {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
        return 'light'; // 기본은 라이트 모드
    }

    function setUserThemeStyleSheet(theme) {
        dispatch(setTheme(theme));

        // body 요소에 theme 클래스 추가
        const element = document.body;
        if (element) {
            // 기존 theme- 클래스들 제거
            element.className = element.className.replace(/theme-\w+/g, '');
            // 새로운 theme 클래스 추가
            element.classList.add(`theme-${theme}`);
        }

        // 기존 테마 CSS 제거
        const existingThemeCSS = document.querySelector('link[data-theme-css]');
        if (existingThemeCSS) {
            existingThemeCSS.remove();
        }

        // 새로운 테마 CSS 로드
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `https://cdn.coursemos.io/css/${theme}-dev.css`;
        link.setAttribute('data-theme-css', theme);
        document.head.appendChild(link);
    }

    return (
        <Box className="box-settings" style={{ padding: 20 }}>
            <div style={{ padding: 10, paddingBottom: 30, borderBottom: '1px solid #ddd' }}>
                <Typography variant="h6" style={{ marginBottom: 15 }}>{t('settings.general.theme')}</Typography>
                <Box display="flex" flexWrap="wrap" gap={2} flexDirection="row" justifyContent="center">
                    <div
                        className="theme-container"
                        onClick={() => {
                            //var userTheme = getUserTheme();
                            var userTheme = "auto";
                            console.log("Auto theme selected : ", userTheme);
                            setUserThemeStyleSheet(userTheme);
                            //dispatch(setTheme(userTheme)) // 브라우저 설정 가져오기
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            transition: 'transform 0.3s, box-shadow 0.3s'
                        }}>
                            <Box
                                className="theme-box-outer"
                                style={{
                                    width: 100,
                                    backgroundColor: '#2E2E2E',
                                }}
                            >
                                <Typography style={{
                                    width: '100%',
                                    paddingTop: 'calc(15% - 7px)',
                                    paddingLeft: '20px',
                                    fontSize: "14px",
                                    color: '#FFFFFF',
                                }}>
                                    Coursemos
                                </Typography>
                                <div className="theme-box-inner"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        color: '#252525',
                                        borderTop: '1px solid #ddd',
                                        borderLeft: '1px solid #ddd',
                                    }}>
                                </div>
                            </Box>
                            <Box
                                className="theme-box-outer"
                                style={{
                                    width: 100,
                                    backgroundColor: '#FFFFFF',
                                }}
                            >
                                <Typography style={{
                                    width: '100%',
                                    paddingTop: 'calc(15% - 7px)',
                                    paddingLeft: '20px',
                                    fontSize: "14px",
                                    color: '#000000',
                                }}>
                                    Coursemos
                                </Typography>
                                <div className="theme-box-inner"
                                    style={{
                                        backgroundColor: '#2E2E2E',
                                        color: '#FFFFFF',
                                        borderTop: '1px solid #ddd',
                                        borderLeft: '1px solid #ddd',
                                    }}>
                                </div>
                            </Box>
                        </div>
                        <div className="theme-box-label">{t('settings.general.auto')}</div>
                    </div>
                    {themesObj.map((theme, index) => (
                        <div
                            className="theme-container"
                            key={index}
                        >
                            <Box
                                key={index}
                                className="theme-box-outer"
                                onClick={() => {
                                    {
                                        //dispatch(setTheme(theme.id));
                                    }


                                    console.log("theme.id : ", theme.id); // 디버깅용
                                    setUserThemeStyleSheet(theme.id);

                                }}
                                style={{
                                    backgroundColor: theme.gradient ? undefined : theme.backgroundColorOuter,
                                    backgroundImage: theme.gradient,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    transition: 'transform 0.3s, box-shadow 0.3s' // Hover 애니메이션
                                }}
                            >
                                <Typography style={{
                                    width: '100%',
                                    paddingTop: 'calc(15% - 7px)',
                                    paddingLeft: '20px',
                                    fontSize: "14px",
                                    color: theme.textColorOuter || "#FFFFFF",
                                }}>
                                    Coursemos
                                </Typography>
                                <div className="theme-box-inner"
                                    style={{
                                        backgroundColor: theme.backgroundColorInner,
                                        color: theme.textColorInner,
                                        borderTop: theme.id === "light" ? '1px solid #ddd' : undefined,
                                        borderLeft: theme.id === "light" ? '1px solid #ddd' : undefined,
                                    }}>
                                </div>
                            </Box>
                            <div className="theme-box-label">{t(`settings.general.${theme.id}`)}</div>
                        </div>
                    ))}

                    <div
                        className={`theme-container theme-${organizationData.organization_code}`}
                    >
                        <Box
                            className="theme-box-outer"
                            onClick={() => {
                                console.log("theme.id : ", organizationData.organization_code); // 디버깅용
                                setUserThemeStyleSheet(organizationData.organization_code);
                            }}
                            style={{
                                backgroundColor: 'var(--theme-primary)',
                                backgroundImage: theme.gradient,
                                display: 'flex',
                                flexDirection: 'column',
                                transition: 'transform 0.3s, box-shadow 0.3s' // Hover 애니메이션
                            }}
                        >
                            <Typography style={{
                                width: '100%',
                                paddingTop: 'calc(15% - 7px)',
                                paddingLeft: '20px',
                                fontSize: "14px",
                                color: theme.textColorOuter || "#FFFFFF",
                            }}>
                                Coursemos
                            </Typography>
                            <div className="theme-box-inner"
                                style={{
                                    backgroundColor: theme.backgroundColorInner,
                                    color: theme.textColorInner,
                                    borderTop: theme.id === "light" ? '1px solid #ddd' : undefined,
                                    borderLeft: theme.id === "light" ? '1px solid #ddd' : undefined,
                                }}>
                            </div>
                        </Box>
                        <div className="theme-box-label">{organizationData.organization_name}</div>
                    </div>

                </Box>
            </div>

            <LangButtons />
        </Box>
    );
}

export default General;